import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { Arrow } from "./Icons";
import { Reveal } from "./Reveal";

export default function Footer() {
  return (
    <footer className="ft">
      <div className="container">
        <div className="ft-cta">
          <Reveal>
            <p className="eyebrow">Begin</p>
            <h2 className="h1" style={{ marginTop: 24 }}>
              Let's make <span className="ital gold">something</span><br />worth keeping.
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="ft-cta-links">
              <Link to="/contact" className="btn solid">Book a consultation <Arrow /></Link>
              <a href="tel:+13038722500" className="link-line">Or call 303 872 2500</a>
            </div>
          </Reveal>
        </div>

        <hr className="rule" />

        <div className="ft-grid">
          <div className="ft-col">
            <p className="eyebrow no-rule">Studio</p>
            <p>910 16th Street, Suite 1223<br />University Building, 12th floor<br />16th &amp; Champa, Denver CO 80202</p>
            <p style={{ marginTop: 16 }}><a href="https://maps.google.com/?q=910+16th+Street+Suite+1223+Denver+CO+80202" target="_blank" rel="noreferrer" className="link-line">Directions</a></p>
          </div>
          <div className="ft-col">
            <p className="eyebrow no-rule">Hours</p>
            <p>Mon, Tue, Wed, Fri<br /><span className="stone">9:30 am to 5:30 pm</span></p>
            <p style={{ marginTop: 10 }}>Thursday<br /><span className="stone">10 am to 7 pm</span></p>
            <p style={{ marginTop: 10 }} className="stone">Evenings by appointment</p>
          </div>
          <div className="ft-col">
            <p className="eyebrow no-rule">Explore</p>
            <ul className="ft-list">
              <li><Link to="/engagement-rings">Engagement rings</Link></li>
              <li><Link to="/custom-jewelry">Custom jewelry</Link></li>
              <li><Link to="/process">Our process</Link></li>
              <li><Link to="/estate">Estate &amp; gold buying</Link></li>
              <li><Link to="/watch-repair">Watch repair</Link></li>
              <li><Link to="/about">About</Link></li>
            </ul>
          </div>
          <div className="ft-col">
            <p className="eyebrow no-rule">Follow</p>
            <ul className="ft-list">
              <li><a href="https://www.instagram.com/bulowjewelers" target="_blank" rel="noreferrer">Instagram</a></li>
              <li><a href="https://www.facebook.com/bulowjewelers" target="_blank" rel="noreferrer">Facebook</a></li>
              <li><a href="https://www.google.com/maps/search/Bulow+Jewelers+Denver" target="_blank" rel="noreferrer">Google reviews</a></li>
              <li><a href="https://www.yelp.com/search?find_desc=Bulow+Jewelers&find_loc=Denver" target="_blank" rel="noreferrer">Yelp</a></li>
            </ul>
          </div>
        </div>

        <div className="ft-mark" aria-hidden="true">
          <StaticImage src="../images/logo-ivory.png" alt="" placeholder="none" layout="constrained" width={1600} />
        </div>

        <div className="ft-bottom">
          <span>© {new Date().getFullYear()} Bulow Jewelers. Family owned in Denver.</span>
          <span className="stone">GIA reports with every diamond. Free cleanings, always.</span>
        </div>
      </div>
      <style dangerouslySetInnerHTML={{ __html: `
        .ft { position: relative; padding-top: clamp(96px, 12vw, 180px); background: var(--ink); overflow: hidden; }
        .ft::before { content: ""; position: absolute; inset: 0; background: radial-gradient(50% 40% at 50% 100%, rgba(201,169,97,.12), transparent 70%); pointer-events: none; }
        .ft-cta { display: grid; grid-template-columns: 1.3fr 1fr; align-items: end; gap: 40px; padding-bottom: clamp(64px, 8vw, 120px); }
        .ft-cta-links { display: flex; flex-wrap: wrap; align-items: center; gap: 32px; justify-content: flex-end; }
        .ft-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 40px; padding: clamp(48px, 6vw, 96px) 0; font-size: .95rem; line-height: 1.7; color: var(--bone); }
        .ft-col .eyebrow { margin-bottom: 18px; }
        .ft-list { list-style: none; margin: 0; padding: 0; display: grid; gap: 6px; }
        .ft-list a { transition: color .3s; } .ft-list a:hover { color: var(--gold-2); }
        .ft-mark { opacity: .07; margin: 0 auto -6%; max-width: 1400px; pointer-events: none; }
        .ft-bottom { display: flex; justify-content: space-between; gap: 20px; flex-wrap: wrap; padding: 28px 0 36px; font-size: .72rem; letter-spacing: .12em; text-transform: uppercase; border-top: 1px solid rgba(244,239,230,.08); position: relative; }
        @media (max-width: 900px) {
          .ft-cta { grid-template-columns: 1fr; }
          .ft-cta-links { justify-content: flex-start; }
          .ft-grid { grid-template-columns: 1fr 1fr; }
        }
      ` }} />
    </footer>
  );
}
